import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MostActiveStockOptionsFull from './most-active-stock-options-full'

const MostActiveStockOptionsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MostActiveStockOptionsFull {...props} />
    </QueryClientProvider>
  );
};

export { MostActiveStockOptionsFullWidget }
